import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  "data-testid": "studio-toast-container",
  class: "!tw-pointer-events-auto tw-flex tw-items-center tw-gap-4 tw-rounded-lg tw-bg-white tw-p-4 tw-text-black tw-shadow-md",
  role: "alert"
}
const _hoisted_2 = { class: "tw-max-w-lg" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioToastSuccessIcon = _resolveComponent("StudioToastSuccessIcon")!
  const _component_StudioToastErrorIcon = _resolveComponent("StudioToastErrorIcon")!
  const _component_StudioButton = _resolveComponent("StudioButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_ctx.mode === 'success')
        ? (_openBlock(), _createBlock(_component_StudioToastSuccessIcon, {
            key: 0,
            "data-testid": "toast-success-icon",
            class: "tw-h-5 tw-w-5"
          }))
        : (_ctx.mode === 'error')
          ? (_openBlock(), _createBlock(_component_StudioToastErrorIcon, {
              key: 1,
              "data-testid": "toast-error-icon",
              class: "tw-h-5 tw-w-5"
            }))
          : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.hasLink)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            innerHTML: _ctx.message
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.message), 1))
    ]),
    (_ctx.action)
      ? (_openBlock(), _createBlock(_component_StudioButton, {
          key: 0,
          trackingId: "studio-toast-action-button",
          variant: "outline",
          size: "small",
          onClick: _ctx.action.callback
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.action.label), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}